import { defineMessages } from 'react-intl';

export default defineMessages({
    rvDeclarationText: {
        id: 'quoteandbind.rv.views.rv-declaration-page.declarationcontent',
        defaultMessage: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    },
    declarationTitle:{
        id: 'quoteandbind.rv.views.rv-declaration-page.declarationtitle',
        defaultMessage: 'Declaration'
    },
    declarationSubTitle:{
        id: 'quoteandbind.rv.views.rv-declaration-page.declarationSubtitle',
        defaultMessage: 'Declaration/Consent'
    },
    declarationconsent: {
        id: 'quoteandbind.rv.views.rv-declaration-page.declarationconsent',
        defaultMessage: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco '
    },
    paymentBuyNow: {
        id: 'quoteandbind.views.Declaration-details.Bind Now',
        defaultMessage: 'Bind Now'
    }
});